import nudgeStore from '../store/Store';

export default function getNudgedRowKeyFromItemId(itemId: string): string {
    const nudgedRow = nudgeStore.nudgedRows.filter(nudgedRow => nudgedRow.itemId === itemId);

    return nudgedRow.length == 1 ? nudgedRow[0].rowKey : null;
}
